import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreativesResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreativesResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreativesResult>(
    {
      results: arrayOf(objectOf({ apiCampaignId: string, name: string })),
    }
  );
